export default __webpack_public_path__ + "static/344-62a9d5c1f75456d58b56cecdb3172e24.gif";